export default function BasketItem (props) {
  const {
    mainId,
    displayName,
    regularPrice,
    quantity,
    removeFromBasket = Function.prototype,
    incQuantity = Function.prototype,
    decQuantity = Function.prototype
  } = props

  return (
    <li className="collection-item">
      {displayName} {' '}
      <i
        className='material-icons basket-quantity'
        onClick={() => incQuantity(mainId)}
      >
        add
      </i>{' '} x {quantity} {' '}
      <i
        className='material-icons basket-quantity'
        onClick={() => decQuantity(mainId)}
      >
        remove
      </i>{' '}
      ={regularPrice}
      <span className="secondary-content" onClick={() => removeFromBasket(mainId)}>
        <i className="material-icons delete-icon">delete_forever</i>
      </span>
    </li>
  )
}